<template>
  <div class="switcher" ref="langRef" v-if="currentLocale">
    <div class="switcher__button" @click="setSwitcherVisible(!isSwitcherVisible)">
      <img class="switcher__button-flag" :src="currentLocale.flag" :alt="currentLocale.code">
    </div>
    <div class="switcher__menu" :class="[{active: isSwitcherVisible}]">
      <img
        class="switcher__menu-button"
        v-for="locale of locales"
        :key="locale.code"
        @click="switchLocale(locale.code)"
        :src="locale.flag"
        :alt="locale.code"
      />
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref, watch} from "vue";
import translations from "@/core/helpers/translations.js";
import {useRoute, useRouter} from "vue-router";
import { onClickOutside } from '@vueuse/core'
import {Languages} from "@/core/api/languages.js";
import translation from "@/core/helpers/translations.js";

const route = useRoute()
const router = useRouter()

const locales = ref([])

const isSwitcherVisible = ref(false)
const setSwitcherVisible = (state) => {
  isSwitcherVisible.value = state
}

const langRef = ref(null)
onClickOutside(langRef, () => isSwitcherVisible.value = false)

const currentLocale = ref(null)

const getLanguages = async () => {
  const res = await Languages.getLanguages()
  locales.value = res.data?.languages.filter((locale) => translation.supportedLocales.includes(locale.code));
  currentLocale.value = locales.value.find((locale) => locale.code === translation.currentLocale)
}

const switchLocale = async (newLocale) => {
  setSwitcherVisible(false)

  translations.switchLanguage(newLocale)

  await router.push({
    name: route.name,
    params: {
      ...route.params,
      locale: newLocale
    },
    query: { ...route.query }
  })
}

watch (
  () => translation.currentLocale,
  () => {
    currentLocale.value = locales.value.find((locale) => locale.code === localStorage.getItem('digitgiftcode-user-locale'))
  }
)

onMounted(async () => {
  await getLanguages()
})
</script>

<style lang="scss" scoped>
.switcher {
  width: 50px;
  position: relative;
  z-index: 3;

  &__button {
    cursor: pointer;
    display: flex;
    gap: 5px;

    &-flag {
      transition: 0.2s;
      width: 100%;
      padding: 5px;
      box-sizing: content-box;
      background-color: #012169;
      border-radius: 5px;
    }
  }

  &__menu {
    position: absolute;
    z-index: 3;
    bottom: 110%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #012169;
    display: flex;
    flex-direction: column;
    max-height: 0;
    overflow: hidden;
    transition: 0.2s;
    border-radius: 5px;

    &.active {
      max-height: 1000px;
    }

    &-button {
      width: 50px;
      cursor: pointer;
      padding: 5px;
      background-color: #012169;
      transition: 0.1s;

      &:first-child {
        padding-top: 10px;
      }
      &:last-child {
        padding-bottom: 10px;
      }

      &:hover {
        background-color: #05ABF3;
      }
    }
  }
}

//@media (max-width: 1680px) {
//  .switcher {
//    &__menu {
//      top: 44px;
//    }
//  }
//}
</style>